import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "o-speechBubble" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "o-speechBubble__backgroundEnforce" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`o-speechBubble__content theme-${$props.speechBubble.theme}`)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */),
    _hoisted_2
  ]))
}